import { createReducer } from "@reduxjs/toolkit";

import {
  clearPolicySettingsStates,
  getPolicySettings,
  getPolicySettingsFailure,
  getPolicySettingsSuccess,
  updatePolicySettings,
  updatePolicySettingsFailure,
  updatePolicySettingsSuccess,
} from "./actions";

const initialState = {
  data: [],
  error: null,
  list: [],
  userById: {},
  isLoading: false,
  isSuccess: false,
  nextOffset: undefined,
  totalCount: undefined,
};

export default createReducer(initialState, (builder) => {
  builder
    .addCase(getPolicySettings.type, (state) => ({
      ...state,
      isLoading: true,
    }))
    .addCase(getPolicySettingsSuccess.type, (state, action) => ({
      ...state,
      data: action.payload,
      isLoading: false,
    }))
    .addCase(getPolicySettingsFailure.type, (state, action) => ({
      ...state,
      isSuccess: false,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(updatePolicySettings.type, (state, action) => ({
      ...state,
      data: action.payload,
      isSuccess: false,
      isLoading: true,
      error: initialState.error,
    }))
    .addCase(updatePolicySettingsSuccess.type, (state, action) => ({
      ...state,
      ...action.payload,
      isSuccess: true,
      isLoading: false,
    }))
    .addCase(updatePolicySettingsFailure.type, (state, action) => ({
      ...state,
      isLoading: false,
      error: action.payload,
    }))
    .addCase(clearPolicySettingsStates.type, (state) => ({
      ...state,
      error: initialState.error,
      isLoading: false,
      isSuccess: false,
    }));
});
